export const COLUMNS = [
    {
        Header: 'Campaign Name',
        accessor: 'campaign_name'
    },
    {
        Header: 'Description',
        accessor: 'description'
    },
    {
        Header: 'Country',
        accessor: 'country'  
    },
    {
        Header: 'City',
        accessor: 'city'

    },
    {
        Header: 'Start Date',
        accessor: 'start_date'
    },
    {
        Header: 'End Date',
        accessor: 'end_date'
    },
  
]